export enum NotificationTypes {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export enum Locales {
  ENG = 'ENG',
  RU = 'RU',
}

export interface ISelect {
  label: string;
  value: string;
  disabled?: boolean;
}
export type Select = {
  label: string;
  value: string;
};
